import { z } from "zod";

export const healthMaintenanceFormSchema = z.object({
  entryType: z.enum(["completed", "declined"]),
  date: z.date(),
});

export type HealthMaintenanceFormData = z.infer<
  typeof healthMaintenanceFormSchema
>;
